<template>
    <div class="test-list">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>B端数据</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search">
            <!-- <div style="margin-left: 2vh;">
                <el-input placeholder="请输入查询id" prefix-icon="el-icon-search" size="small"
                    v-model="communityId"></el-input>
            </div>
            <div> <el-button type="primary" size="small" @click.native="Query">查询</el-button></div>
            <div style="margin-left:20px;"> <el-button type="success" size="small"
                    @click.native="resetting">重置</el-button>
            </div> -->
        </div>
        <div class="list">
            <el-table :data="dataList" ref="dataList" style="width: 100%" :row-class-name="tableRowClassName"
                size="mini" stripe>
                <el-table-column prop="user_id" label="用户ID" fixed="left" width="80"></el-table-column>
                <el-table-column prop="name" label="姓名" fixed="left" width="80"></el-table-column>
                <el-table-column prop="mobile" label="手机号"></el-table-column>
                <el-table-column prop="payment_amount" label="支付金额(元)"></el-table-column>
                <el-table-column prop="payment_time" label="支付时间"></el-table-column>
                <el-table-column prop="register_time" label="登录时间"></el-table-column>
            </el-table>
        </div>
        <div class="block">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.page" :page-sizes="[10, 20, 30, 40]" :page-size="pagination.per_page"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total_count">
            </el-pagination>
        </div>
    </div>
</template>


<script>
export default {
    data() {
        return {
            dataList: [],
            total: 0,
            pagination: {
                per_page: 10,
                page: 1
            }
        }
    },
    created() {
        this.getTaskList()
    },
    methods: {
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex % 2 === 1) {
                return '';
            } else {
                return 'success-row';
            }
        },
        getTaskList() {
            this.$get(`/v1/admin/b-report?pages=${this.pagination.page}&limit=${this.pagination.per_page}&community_id=${this.$route.query.community_id}`, {}).then((res) => {
                console.log(res.data.users, '=========')
                if (res.status === 200) {
                    let resData = res.data
                    let list = res.data.users
                    list.forEach(user => {
                        user.payment_amount /= 100;
                    });
                    this.dataList = list
                    this.pagination = resData.pagination
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        handleSizeChange(val) {
            console.log(val)
            this.pagination.per_page = val;
            this.getTaskList()
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTaskList()
        },
        resetting() {
            this.communityId = ''
            this.getTaskList();
        },
        Query() {
            this.pagination.page = 1;
            this.getTaskList();
        },
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
   .el-select .el-input {
      width: 200px;
    }
  .test-list
      .el-table .warning-row {
        background: oldlace;
      }
  
      .el-table .success-row {
        background: #f0f9eb;
      }
  
      .search
        margin 20px 0
        display flex
        justify-content flex-start
        input
          width 200px
          margin-right 20px
        .add
          padding-left 100px
  
      .list
        min-height 550px
        border 1px solid #EBEEF5
        .edit_icon
          width 20px
          height 20px
          margin-left 16px
          border 1px solid  #ccc
          border-radius 4px
  
  </style>


// WEBPACK FOOTER //
// src/pages/B-end/B-end.vue